import CryptoJS from 'crypto-js';

export const decryptVirtualCardMessage = (number: string, message: string | undefined) => {
    if (typeof message === 'undefined') {
        throw new Error('Virtual card error');
    }

    const key = CryptoJS.enc.Utf8.parse(number);
    const encryptedMessage = CryptoJS.enc.Hex.parse(message);

    // @ts-expect-error some issue with crypto-js
    const decrypted = CryptoJS.AES.decrypt({ ciphertext: encryptedMessage }, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });

    const decipheredMessage = decrypted.toString(CryptoJS.enc.Utf8);
    return decipheredMessage;
};
